import { Trans } from 'react-i18next'

import styled from 'styled-components'
import ourGoalsPNG from '~/assets/images/history/history-our-goals.png'
import ourGoalsWEBP from '~/assets/images/history/history-our-goals.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const ImageWrapper = styled(S.ImageWrapper)`
  width: 275px;
  max-width: 100%;
  margin: 0 auto;
`

const OurGoalsArt = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Our goal is to help you achieve yours',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <ImageWrapper>
          <picture>
            <source srcSet={ourGoalsWEBP} type="image/webp" />
            <img src={ourGoalsPNG} alt="Learn, Practice, Implement" />
          </picture>
        </ImageWrapper>

        <S.Title>
          <Trans ns="history" i18nKey="onboarding.historyOurGoals.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="history" i18nKey="onboarding.historyOurGoals.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default OurGoalsArt
